export default "__VITE_ASSET__BOf1r_56__"